module.exports = __webpack_public_path__ + "static/img/Bachelor_010357.96f1cd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010357.jpg
// module id = 155
// module chunks = 0